export default {
  async all(userId, config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/admin/personal/users/${userId}/comments`,
      headers: this.headers,
      ...config,
    });
  },
};
